import { type CustomFieldDto, usePricingControllerComputePricing } from 'korint-sdk';
import { useDebouncedValue } from 'korint-sdk/react';
import { type ManualComponentValuesMap, serializeManualValues } from './manual-components';

export function useComputePricing({
  policyId,
  branchId,
  tierId,
  selectedPerilIds,
  policyCustomFieldsInputs,
  policyCustomFields,
  assetCustomFields,
  manualComponentValues,
  enabled = true,
}: {
  policyId: string;
  branchId?: string;
  tierId?: string;
  selectedPerilIds?: string[];
  policyCustomFieldsInputs: Record<string, unknown>;
  policyCustomFields?: CustomFieldDto[];
  assetCustomFields?: CustomFieldDto[];
  manualComponentValues?: ManualComponentValuesMap;
  enabled?: boolean;
}) {
  const debouncedParams = useDebouncedValue(policyCustomFieldsInputs, 300);
  const debouncedPolicyCustomFields = useDebouncedValue(policyCustomFields, 300);
  const debouncedAssetCustomFields = useDebouncedValue(assetCustomFields, 300);
  const debouncedManualValues = useDebouncedValue(manualComponentValues, 300);

  return usePricingControllerComputePricing(
    policyId,
    {
      tierId: tierId!,
      selectedPerilIds,
      branchId,
      policyCustomFieldsInputs:
        Object.keys(debouncedParams).length > 0 ? JSON.stringify(debouncedParams) : undefined,
      policyCustomFields: debouncedPolicyCustomFields?.length
        ? JSON.stringify(debouncedPolicyCustomFields)
        : undefined,
      assetCustomFields: debouncedAssetCustomFields?.length
        ? JSON.stringify(debouncedAssetCustomFields)
        : undefined,
      manualComponentValues: serializeManualValues(debouncedManualValues),
    },
    {
      query: {
        enabled: enabled && !!tierId,
        retry: 0,
      },
    },
  );
}
